import Index from '../../pages/servitor/bbj/index';
import Index2 from '../../pages/servitor/bbj/index2';
import Help from '../../pages/servitor/bbj/help';

const base = 'bbj';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  // 测试用
  {
    path: `/${base}/test*`,
    name: `${base}-test`,
    component: Index2
  },
  {
    path: `/${base}/help*`,
    name: `${base}-help`,
    component: Help
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/servitor/bbj.js